<template>
  <v-btn
    outlined
    v-bind="$attrs"
    @click="$emit('click')">
    {{label}}
  </v-btn>
</template>

<script>
export default {
  name: 'EsButtonCancel',
  props: {
    label: {
      type: String,
      required: false,
      default: 'Cancel'
    },
  }
};
</script>
